import { LightningElement, api, wire } from "lwc";
import { LabelsAdapter } from "common/labelsAdapter";

var data$7 = {
  close: "Schließen",
  info: "Info",
  success: "Erfolg",
  error: "Fehler",
};
data$7.close;
data$7.info;
data$7.success;
data$7.error;

var data$6 = {
  close: "Close",
  info: "info",
  success: "success",
  error: "error",
};
data$6.close;
data$6.info;
data$6.success;
data$6.error;

var data$5 = {
  close: "Cerrar",
  info: "información",
  success: "operación realizada correctamente",
  error: "error",
};
data$5.close;
data$5.info;
data$5.success;
data$5.error;

var data$4 = {
  close: "Fermer",
  info: "information",
  success: "réussi",
  error: "erreur",
};
data$4.close;
data$4.info;
data$4.success;
data$4.error;

var data$3 = {
  close: "閉じる",
  info: "情報",
  success: "成功",
  error: "エラー",
};
data$3.close;
data$3.info;
data$3.success;
data$3.error;

var data$2 = { close: "닫기", info: "정보", success: "성공", error: "오류" };
data$2.close;
data$2.info;
data$2.success;
data$2.error;

var data$1 = {
  close: "Fechar",
  info: "informações",
  success: "sucesso",
  error: "erro",
};
data$1.close;
data$1.info;
data$1.success;
data$1.error;

var data = { close: "关闭", info: "信息", success: "成功", error: "错误" };
data.close;
data.info;
data.success;
data.error;

var locales = /*#__PURE__*/ Object.freeze({
  __proto__: null,
  de: data$7,
  en: data$6,
  esMX: data$5,
  fr: data$4,
  ja: data$3,
  ko: data$2,
  ptBR: data$1,
  zhCN: data,
});

const icons = {
  info: "info",
  warning: "warning",
  success: "success",
  error: "error",
};
const defaultHtmlConfig = {
  ALLOWED_TAGS: ["a", "strong", "em"],
};
class toast extends LightningElement {
  @api variant = "info";
  @api message = undefined;
  @api unsafeMessage = undefined;
  @api htmlConfig = defaultHtmlConfig;
  @wire(LabelsAdapter, {
    locales,
  })
  labels = null;

  get isUnsafe() {
    return !this.message && this.unsafeMessage;
  }

  get iconAssistiveText() {
    // eslint-disable-next-line
    return this.labels[this.variant] || this.labels.info;
  }

  get iconSymbol() {
    return icons[this.variant] || icons.info;
  }

  get className() {
    return `toast toast--${this.variant}`;
  }

  handleRequestClose() {
    this.dispatchEvent(new CustomEvent("requestclose"));
  }
}

export default toast;
export { defaultHtmlConfig };
